import { Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

type StartRouteProps = {
  children: React.ReactNode;
  style?: React.CSSProperties;
};

export const RouteFooterContainer = ({ children, style }: StartRouteProps) => {
  return (
    <Grid
      style={{
        position: `absolute`,
        bottom: 0,
        left: 0,
        width: `100%`,
        display: `flex`,
        justifyContent: `center`,
        alignItems: `center`,
        height: `70px`,
        zIndex: 1005,
        backgroundColor: RoutalPalette.white,
        padding: `0 14px`,
        borderTop: `1px solid ${RoutalPalette.neutral10}`,
        ...style,
      }}
    >
      {children}
    </Grid>
  );
};
